import { h } from "@stencil/core";
export const BrokenFile = ({ file }) => {
    const iconName = iconForStatus(file.status);
    return (h("div", null, h("a", { class: "error", href: file.url }, h("div", null, h("ion-icon", { name: iconName })), h("div", { class: "code" }, file.status.code), h("div", { class: "text" }, file.status.text))));
};
function iconForStatus(status) {
    switch (status.code) {
        case 401:
        case 403:
            return 'lock-closed-outline';
        case 404:
            return 'help-circle-outline';
        default:
            return 'alert-circle-outline';
    }
}
//# sourceMappingURL=BrokenFile.js.map
